import React from "react";
import { Layout } from "antd";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./layout.css";

const { Content } = Layout;

export default function index(props) {
  const {useButton} = props
  return (
    <Layout style={{ backgroundColor: "#00A0EA", minHeight: "100vh" }}>
      <Navbar useButton={useButton} />
      <Content style={{ backgroundColor: "#00A0EA", marginTop: 80 }}>
        {props.children}
      </Content>
      <Footer />
    </Layout>
  );
}
